export default "__VITE_PUBLIC_ASSET__63ed73e1__"